<template>
  <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="visible">
    <template slot="title">
      <img v-if="badgeInfos.type == 'custom' && badgeInfos.content.img" :src="$apiDomain + '/imgs/' + badgeInfos.content.img">
      <img v-else :src="$getBadgeAsset(nbFeuille)">
      <br />
      <template v-if="badgeInfos.type == 'custom'">
        {{ badgeInfos.content.title }}
      </template>
      <template v-else-if="badgeInfos.type == 'contrat'">
        Vente validée &#x1F44C;
      </template>
      <template v-else-if="badgeInfos.type == 'vente'">
        Demande envoyée &#x1F44C;
      </template>
      <template v-else>
        Bravo &#x1F44F;
      </template>
    </template>
    <span v-for="(item, index) in content" :key="index">
      <span v-html="item" @click="openFlashLink"></span>
      <br>
    </span>
    <template slot="footer">
      <v-ons-alert-dialog-button v-show="['vente', 'contrat'].indexOf(badgeInfos.type) != -1 || (badgeInfos.type == 'custom' && badgeInfos.content.cancel)" @click="hide">
        {{ badgeInfos.type == 'custom' ? badgeInfos.content.cancel : 'Fermer' }}
      </v-ons-alert-dialog-button>
      <v-ons-alert-dialog-button v-show="badgeInfos.type == 'custom' && badgeInfos.content.ok" modifier="primal" @click="showDeeplink">
        {{ badgeInfos.content.ok }}
      </v-ons-alert-dialog-button>
      <v-ons-alert-dialog-button v-show="['vente', 'contrat'].indexOf(badgeInfos.type) != -1" modifier="primal" @click="showHomeVente">
        Voir mes ventes
      </v-ons-alert-dialog-button>
      <v-ons-alert-dialog-button v-show="badgeInfos.type == 'feuille'" modifier="primal" @click="hide">
        Compris !
      </v-ons-alert-dialog-button>
    </template>
  </v-ons-alert-dialog>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    badgeInfos() {
      return this.state.badge;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    now() {
      return this.data.now;
    },
    content() {
      if (this.badgeInfos.type == 'custom') {
        return this.evalDate(this.badgeInfos.content.msg);
      } else if (this.badgeInfos.type == 'contrat') {
        return ["Votre demande de vente a bien été validée par votre OS."];
      } else if (this.badgeInfos.type == 'vente') {
        return ["La demande a bien été transmise à votre OS et vous serez notifié dés qu'elle sera validée."];
      } else if (this.nbFeuille == 1) {
        return ['Vous avez fini de configurer votre compte, vous gagnez votre Première Feuille.'];
      } else if (this.nbFeuille == 2) {
        return ['Vous venez de créer une alerte, vous gagnez votre Deuxième Feuille.'];
      } else if (this.nbFeuille == 3) {
        return ["Vous venez d'enregistrer une vente, vous gagnez votre Troisième Feuille."];
      } else {
        return [];
      }
    },
    visible() {
      return this.badgeInfos.type !== '';
    }
  },
  methods: {
    hide() {
      store.state.badge.type = '';
    },
    showHomeVente() {
      this.hide();
      this.pageStack.splice(1, this.pageStack.length - 1);
      this.$emit('show-home', {
        id: 'ventes',
        refCulture: this.badgeInfos.refCulture,
        refDestination: this.badgeInfos.refDestination,
      });
    },
    showDeeplink() {
      this.hide();
      var path = this.badgeInfos.content.deeplink.split('/');
      path.shift(); // root /
      var pathItem = path.shift(); // app/
      if(pathItem == 'tel'){
        pathItem = path.shift();
        this.$callTel(pathItem);
      } else {
        pathItem = path.shift();
        var idMulti = Math.floor(parseInt(this.user.id) / 100).toString() + pathItem.toString();
        this.$emit('change-multi', {
          idMulti: idMulti,
          initPath: idMulti + '/' + path.join('/')
        });
      }
      this.sendTrackEvent('popup ok ' + this.badgeInfos.content.deeplink);
    }
  }
}
</script>

<style>
.alert-dialog-button--material {
  font-weight: 400;
}
.alert-dialog-button--primal--material {
    font-weight: 500;
}
</style>